/**
 * PipeInspectionForm refactor'unun yerel tipleri.
 *
 * NOT: Global `QaqcPipeInspRcrdDetail.payload: Record<string, any>` (types/index.ts)
 * bilerek daraltılmadı; bu tipler yalnız inspection-form modülü içinde sözleşmedir.
 * DB'deki mevcut payload'larla uyum için katı discriminated union DEĞİL:
 * `result` her zaman var, tip anahtarı (bc/vc/pt/mt/ut) opsiyoneldir ve decode
 * payload ANAHTARINA göre dallanır (inspectionType'a değil).
 */

export type InspectionTypeCode = 'BC' | 'VC' | 'PT' | 'MT' | 'UT' | 'PWHT';

export type InspectionResult = 'PASS' | 'FAIL' | 'REWORK';

export interface WeldMeta {
  pipe_size?: string | null;
  service_class_name?: string | null;
  weldtype_name?: string | null;
  spool_id?: number | null;
  weld_category?: string | null;
  code_no?: string | null;
  fluid?: string | null;
}

export interface BcPayload {
  bevel_angle: number | null;
  root_face_mm: number | null;
  root_gap_mm: number | null;
  hi_lo_mm: number | null;
  ovality_ok: boolean;
  prep_method: string | null;
  cleaning_ok: boolean;
  cracks: boolean;
  laminations: boolean;
  rust: boolean;
  paint_oil: boolean;
  size_spacing: boolean;
  defects_free: boolean;
  electrode_batch_ok: boolean;
  preheat_ok: boolean;
  preheat_temp: number | null;
  ambient_ok: boolean;
  heat_no_1: string | null;
  heat_no_2: string | null;
  remarks: string | null;
}

export interface VcPayload {
  weld_size_ok: boolean;
  reinforcement_ok: boolean;
  contour_ok: boolean;
  undersize_oversize_ok: boolean;
  no_cracks: boolean;
  no_porosity: boolean;
  undercut_ok: boolean;
  no_overlap: boolean;
  fusion_fill_ok: boolean;
  root_condition_ok: boolean;
  penetration_ok: boolean;
  root_reinforcement_ok: boolean;
  slag_spatter_removed: boolean;
  no_foreign_inclusions: boolean;
  toes_adjacent_clean: boolean;
  discoloration_ok: boolean;
  no_haz_cracking: boolean;
  coating_damage_checked: boolean;
  misalignment_ok: boolean;
  no_twist_bow: boolean;
  dimensional_checks_ok: boolean;
  smooth_transition_tack_ok: boolean;
  spatter_ok: boolean;
  remarks: string | null;
  flw_welder: string | null;
  fw_welder: string | null;
  /** encode üretmez; Create/Edit persist overlay'i ekler (mergeVcOverlay) */
  flw_date?: string | null;
  fw_date?: string | null;
}

export interface PtPayload {
  surface_cleaned: boolean;
  penetrant_type: string | null;
  dwell_time_min: number | null;
  surface_cleaned_no_residue: boolean;
  type: string | null;
  development_time_min: number | null;
  no_cracks: boolean;
  proper_fusion: boolean;
  no_porosity: boolean;
  no_laps: boolean;
  post_cleaning: boolean;
  remarks: string | null;
}

export interface MtPayload {
  clean: boolean;
  coating_removed: boolean;
  method: string | null;
  current_type: string | null;
  current_amperes: string | null;
  lift_test: string | null;
  flux_density: string | null;
  field_units: string | null;
  particle_type: string | null;
  particle_brand_batch: string | null;
  particle_applied: boolean;
  lighting: string | null;
  lighting_unit: 'uv' | 'lux' | null;
  development_time_min: number | null;
  no_cracks: boolean;
  proper_fusion: boolean;
  no_porosity: boolean;
  no_laps: boolean;
  post_cleaning: boolean;
  remarks: string | null;
}

export interface UtPayload {
  equipment: string | null;
  probe_type: string | null;
  frequency_mhz: string | null;
  probe_angle: string | null;
  calibration_block: string | null;
  couplant_type: string | null;
  scan_method: string | null;
  scan_coverage: string | null;
  coverage_percent: string | null;
  sensitivity_mode: string | null;
  sensitivity_db: string | null;
  range_value: string | null;
  range_unit: string | null;
  sweep_value: string | null;
  sweep_unit: string | null;
  gate_start: string | null;
  gate_width: string | null;
  gate_threshold_percent: string | null;
  no_cracks: boolean;
  proper_fusion: boolean;
  no_porosity: boolean;
  no_laps: boolean;
  remarks: string | null;
}

export interface InspectionDetailPayload {
  result: InspectionResult;
  /** yalnız PWHT */
  hardness?: number | null;
  bc?: BcPayload;
  vc?: VcPayload;
  pt?: PtPayload;
  mt?: MtPayload;
  ut?: UtPayload;
}

/** buildInspectionPatch çıktısı — Form'daki hidden alanlara yazılan yama */
export interface InspectionPatch {
  results_codes: string[];
  has_fail_or_rework: boolean;
  fail_count: number;
  rework_count: number;
  combined_remarks: string;
  pwht_hardness_list: number[] | undefined;
  pwht_hardness_out_of_range: boolean;
  pwht_hardness_invalid_welds: string[];
  details_payloads: InspectionDetailPayload[];
  require_fail_rework_explanation: boolean;
  final_notes: string | undefined;
}

export const SECTION_HEADER_WIDTH = 80;
